export default {
  maxScore: 120,
};
